import { isElementNode } from 'anodum';
import defineSupportedTags from './define-supported-tags';
import transformElementTag from './transform-element-tag';
import normalizeStyleAttribute from './normalize-style-attribute';

const convertElementToSupported = (element) => {
  if (!isElementNode(element)) return;

  const definedTags = defineSupportedTags(element);
  const convertedElement = transformElementTag(element, definedTags[0]);
  if (definedTags.length > 1) {
    const tagsToWrap = definedTags.slice(1);
    const childNodes = document.createDocumentFragment();
    childNodes.append(...convertedElement.childNodes);

    const newChildNodes = tagsToWrap.reduceRight((acc, tag) => {
      const newElement = document.createElement(tag);
      newElement.appendChild(acc);
      return newElement;
    }, childNodes);
    convertedElement.appendChild(newChildNodes);
  }
  normalizeStyleAttribute(convertedElement);
};

export default convertElementToSupported;
